// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"fd7413b0","453":"4efc2a42","626":"e503d87c"}[chunkId] + ".chunk.js";
};